module.exports = __webpack_public_path__ + "static/media/delete-files.2521a831.svg";